import { render } from "./mPRTResult.vue?vue&type=template&id=4bd9844a&scoped=true"
import script from "./mPRTResult.vue?vue&type=script&lang=js"
export * from "./mPRTResult.vue?vue&type=script&lang=js"

import "./mPRTResult.vue?vue&type=style&index=0&id=4bd9844a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd9844a"]])

export default __exports__